/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$('.js-sustainabilityNav').on({
  mouseenter: function () {
    if (window.matchMedia('(min-width:640px)').matches) {
      let img = $(this).children('.js-sustainabilityNav-text').attr('src')
      img = img.replace('.png', '_on.png')
      $(this).children('.js-sustainabilityNav-text').attr('src', img)
    }
  },
  mouseleave: function () {
    if (window.matchMedia('(min-width:640px)').matches) {
      let img = $(this).children('.js-sustainabilityNav-text').attr('src')
      img = img.replace('_on.png', '.png')
      $(this).children('.js-sustainabilityNav-text').attr('src', img)
    }
  },
})

$('.js-sustainabilityItem-hover').on({
  mouseenter: function () {
    const obj = $(this).parents('.js-sustainabilityItem')
    const index01 = obj.attr('id').slice(-2)
    const index02 = ('00' + ($(this).index() + 1)).slice(-2)
    let img = 'top_item_' + index01 + '_' + index02 + '_bg'
    if (window.matchMedia('(max-width:639px)').matches) {
      img = img + '_sp'
    }
    img = img + '.png'
    obj.css('background-image', 'url("./img/' + img + '")')
  },
  mouseleave: function () {
    const obj = $(this).parents('.js-sustainabilityItem')
    const index = obj.attr('id').slice(-2)
    let img = 'top_item_' + index + '_01_bg'
    if (window.matchMedia('(max-width:639px)').matches) {
      img = img + '_sp'
    }
    img = img + '.png'
    obj.css('background-image', 'url("./img/' + img + '")')
  },
})
